import { SafePromise } from '@benzinga/safe-await';
import { Subscribable } from '@benzinga/subscribable';

import { Session } from '@benzinga/session';
import { MortgageRateTrendChartDataPoint } from './entities';
import { MortgageRatesRequest, MortgageRatesRequestEvent } from './request';

export type MortgageRatesManagerEvent = MortgageRatesRequestEvent;

export class MortgageRatesManager extends Subscribable<MortgageRatesManagerEvent> {
  private request: MortgageRatesRequest;

  constructor(session: Session) {
    super();
    this.request = new MortgageRatesRequest(session);
  }

  public static getName = () => 'mortgage-rates';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://us-real-estate.p.rapidapi.com/'),
  });

  public getMortgageRateTrends = async (): SafePromise<MortgageRateTrendChartDataPoint[] | undefined> => {
    return await this.request.getMortgageRateTrends();
  };
}
